import React, { Component } from 'react';
import { Form, Button, Col, Container,Row } from 'react-bootstrap';
import { paymentEndpoints } from "../../constant/Environment";
import { useNavigate } from "react-router-dom";

class TransactionsSummarySearch extends Component{
    constructor(props) {
        super(props);
        console.log(props);
      }

      state = {
        player: "",
        method:"1",
        status:"",
        fromdate: "",
        todate: "",
        accounNumber:""
      };
      
      addNew = () => {
       this.props.addNew();
      }
      searchList = () => {
        this.props.searchList(this.state);
       }
      
    exportCsv = (e) => {
        e.preventDefault();
        var body = {
            player: this.state.player,
            method: this.state.method,
            status:this.state.status,
            fromdate: this.state.fromdate,
            todate:this.state.todate,
            accounNumber:this.state.accounNumber
        }
    
        fetch(`${paymentEndpoints.apiBaseUrl+this.props.report+'/csv'}`, {
                    method: 'POST',
                    body: JSON.stringify(body),
                    responseType: 'blob',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                }).then(function(response) {
                    response.blob().then(blob => {
                        const link = document.createElement('a');
                        const url = URL.createObjectURL(blob);
                        console.log(url);
                        link.href = url;
                        link.download = 'TransferSummaryReport.csv';
                        link.click();
                    })
                   
                });
    };
    exportPdf = (e) => {
        e.preventDefault();
        var body = {
            player: this.state.player,
            method: this.state.method,
            status:this.state.status,
            fromdate: this.state.fromdate,
            todate:this.state.todate,
            accounNumber:this.state.accounNumber
        }
        fetch(`${paymentEndpoints.apiBaseUrl+this.props.report+'/pdf'}`, {
                    method: 'POST',
                    body: JSON.stringify(body),
                    responseType: 'blob',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                }).then(function(response) {
                    response.blob().then(blob => {
                        const link = document.createElement('a');
                        const url = URL.createObjectURL(blob);
                        console.log(url);
                        link.href = url;
                        link.download = 'TransferSummaryReport.pdf';
                        link.click();
                    })
                });
    };
    render() {
        return( <Container fluid>
                    <Form>
                    <Row>
                   
   <Col>
                            <Form.Group as={Col} controlId="formName">
                                <Form.Label className="label">Player</Form.Label>
                                <Form.Select                    
                                name="platform"
                                value={this.state.player}
                                onChange={e => this.setState({ player: e.target.value })}                           
                                >
                                    <option value="">All</option>
           
                                </Form.Select>
                            </Form.Group>
                            </Col>
                            <Col>
                            <Form.Group as={Col} controlId="formPlatform">
                            <Form.Label className="label">Payment Method</Form.Label>
                            <Form.Select                    
                                name="platform"
                                value={this.state.platform}
                                onChange={e => this.setState({ platform: e.target.value })}                           
                                >

                        <option value="1">All</option>
                        <option value="2">Deposit</option>
                        <option value="3">Withdrawal</option>
                                </Form.Select>
                            </Form.Group>
                            </Col>
                            <Col>
                            <Form.Group as={Col} controlId="fromdate">
                                <Form.Label className="label">From Date</Form.Label>
                                <Form.Control
                                type="date"                           
                                name="fromdate"
                                value={this.state.fromdate}
                                onChange={e => this.setState({ fromdate: e.target.value })}
                           
                                />
                            </Form.Group>
                            </Col>
                       

                        <Col>
                        <Form.Group as={Col} controlId="todate">
                                <Form.Label className="label">To Date</Form.Label>
                                <Form.Control
                                type="date"                           
                                name="todate"
                                value={this.state.todate}
                                onChange={e => this.setState({ todate: e.target.value })}
                           
                                />
                            </Form.Group>
                            </Col>  
                           
                        </Row>
                        
                        <Row>
                        <Col>
                        <Form.Group as={Col} controlId="formAccount">
                                <Form.Label className="label">Account Number</Form.Label>
                                <Form.Control
                                type="text"                           
                                name="account"
                                value={this.state.accounNumber}
                                onChange={e => this.setState({ accounNumber: e.target.value })}
                                />
                            </Form.Group>
                            </Col>
                        
                                <Col>
                                <Form.Group as={Col} controlId="formAccount">
                                <Form.Label className="label">Account Status</Form.Label>
                                <Form.Select                    
                                name="platform"
                                value={this.state.status}
                                onChange={e => this.setState({ status: e.target.value })}                           
                                >
                        <option value="">All</option>
                        <option value="1">Active</option>
                        <option value="2">Inactive</option>
                        <option value="3">Suspended</option>
                        <option value="34">Block</option>
                        
                                </Form.Select>
                            </Form.Group>
                            </Col>                
                           
                            <Col>
                           
                            <Form.Group as={Col}>
                       
   <Button className='exportbtn' onClick={this.exportPdf}>
   <img src="/images/icons/pdf.png" />
   </Button>
    
   <Button className='exportbtn' onClick={this.exportCsv}>
   <img src="/images/icons/csv.png" />
   </Button>

   </Form.Group>
   </Col>
   <Col>
   <Form.Group as={Col}>
                        <Button variant="primary" onClick={this.searchList}>Search</Button>
                      
                       </Form.Group>

                        </Col>
                         {/* <Col></Col> */}
                        </Row>
                    </Form>
                </Container>
        );
    }
}

export default TransactionsSummarySearch;